import { createSlice } from "@reduxjs/toolkit";
import { getErrorMessage } from "utils";

const initialState = {};

export const errorSlice = createSlice({
  name: "error",
  initialState,
  reducers: {
    populateErrorMessage: (state, action) => {
      return { ...state, errorMessage: getErrorMessage(action.payload) };
    },
    removeErrorMessage: (state) => {
      return { ...state, errorMessage: undefined };
    },
  },
});

export const { populateErrorMessage, removeErrorMessage } = errorSlice.actions;

export default errorSlice.reducer;
